import { useAppSelector } from 'store/hooks';
import { tenantsApi } from 'components/tenants/tenantsApi';
import { MESSAGE_APP_ID_CREATION_FAILED, MESSAGE_APP_ID_CREATION_SUCCESSFUL } from 'config/messages';
import React from 'react';
import { useSnackbar } from 'notistack';
export interface IAppIdsDetails {
    loading?: boolean;
    listLoading?: boolean;
    ids?: string[];
}

export function useMerchantAppIds() {
    const { enqueueSnackbar } = useSnackbar();
    const { tenant } = useAppSelector(state => state.auth);
    const [appIdDetails, setAppIdDetails] = React.useState<IAppIdsDetails>({});
    const getAppIds = React.useCallback(() => {
        setAppIdDetails(oldValues => ({ ...oldValues, listLoading: true }));
        tenantsApi
            .get(tenant.tenantId)
            .then(response => {
                setAppIdDetails(oldValues => ({ ...oldValues, ids: response.body.applicationIds }));
            })
            .catch(err => {
                enqueueSnackbar(`Unexpected error '${err.message}' while getting app IDs`, {
                    variant: 'error'
                });
            })
            .finally(() => {
                setAppIdDetails(oldValues => ({ ...oldValues, listLoading: false }));
            });
    }, [tenant.tenantId, enqueueSnackbar]);
    React.useEffect(() => {
        getAppIds();
    }, [getAppIds]);

    const handleAddAppId = React.useCallback(
        (value: string) => {
            setAppIdDetails(oldValues => ({ ...oldValues, loading: true }));
            tenantsApi
                .createAppId(tenant.tenantId, value)
                .then(res => {
                    if (res.body) {
                        setAppIdDetails(oldValues => ({ ...oldValues, ids: res.body.applicationIds }));
                        enqueueSnackbar(MESSAGE_APP_ID_CREATION_SUCCESSFUL, { variant: 'success' });
                    } else {
                        enqueueSnackbar(res.error || res.validationError || MESSAGE_APP_ID_CREATION_FAILED, {
                            variant: 'error'
                        });
                    }
                })
                .catch(err => {
                    enqueueSnackbar(`Unexpected error '${err.message}' while creating app ID`, {
                        variant: 'error'
                    });
                })
                .finally(() => {
                    setAppIdDetails(oldValues => ({ ...oldValues, loading: false }));
                });
        },
        [tenant.tenantId, enqueueSnackbar]
    );

    return { appIdDetails, handleAddAppId };
}
